import * as React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import AppNavbar from '../components/AppNavbar';
import Header from '../components/Header';
import { Button  } from '@mui/material';
import SideMenu from '../components/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import TDPGallery from '../components/TDPGallery';

import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};
export default function TDP(props) {
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Header breadcrumbItems={[
            {label: 'AMX xConsole', href: '/'},
            {label: 'xTDP'},
          ]}/>
          <Button variant="contained" color="primary" onClick={() => window.location.href = '/create-tdp'}>
            Create New xTDP
          </Button>
          <TDPGallery />
        </Box>
      </Box>
    </AppTheme>
  );
}
